import React from "react";
import { Link } from "react-router-dom";
import { FiMapPin, FiPhone, FiMail } from "react-icons/fi";
import { useFormControl } from "./../hooks/useFormControl";

const STATE_INICIAL = {
  user_name: "",
  user_email: "",
  user_subject: "",
  message: "",
  website: "",
};

export default function Contact() {
  const { dataUser, sended, spinner, errorForm, handleChange, handleSubmit } =
    useFormControl(STATE_INICIAL);

  return (
    <section className="contact" id="contact">
      <div className="section__container">
        <div className="section__header">
          <span className="section__index">05</span>
          <div>
            <span className="section__tag">Contact / Next step</span>
            <h2 className="section__title">Have a complex problem worth solving?</h2>
          </div>
        </div>
        <div className="contact__grid">
          <div className="contact__form-wrapper">
            <div className="contact__form-heading">
              <span>Message channel</span>
              <h3>Tell me about your idea.</h3>
            </div>
            <form
              className="contact__form"
              id="contact_form"
              onSubmit={handleSubmit}
            >
              {errorForm && (
                <div className="contact__alert contact__alert--error">
                  {errorForm}
                </div>
              )}
              {sended && (
                <div className="contact__alert contact__alert--success">
                  {sended}
                </div>
              )}
              <div className="contact__field">
                <label htmlFor="user_name">Name</label>
                <input
                  id="user_name"
                  type="text"
                  name="user_name"
                  placeholder="Your name"
                  value={dataUser.user_name}
                  onChange={handleChange}
                  maxLength={120}
                  required
                />
              </div>
              <div className="contact__field">
                <label htmlFor="user_email">Email</label>
                <input
                  id="user_email"
                  type="email"
                  name="user_email"
                  placeholder="your@email.com"
                  value={dataUser.user_email}
                  onChange={handleChange}
                  maxLength={254}
                  required
                />
              </div>
              <div className="contact__field">
                <label htmlFor="user_subject">Subject</label>
                <input
                  id="user_subject"
                  type="text"
                  name="user_subject"
                  placeholder="Subject"
                  value={dataUser.user_subject}
                  onChange={handleChange}
                  maxLength={180}
                  required
                />
              </div>
              <div className="contact__field">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Write your message..."
                  value={dataUser.message}
                  onChange={handleChange}
                  maxLength={5000}
                  required
                />
              </div>
              <div className="contact__honeypot" aria-hidden="true">
                <label htmlFor="website">Website</label>
                <input
                  id="website"
                  type="text"
                  name="website"
                  value={dataUser.website}
                  onChange={handleChange}
                  tabIndex={-1}
                  autoComplete="off"
                />
              </div>
              <div className="contact__submit-row">
                {spinner && <div className="contact__spinner"></div>}
                <button className="contact__submit" type="submit" disabled={spinner}>
                  {spinner ? "Sending..." : "Send Message"}
                </button>
              </div>
              <p className="contact__privacy">
                Mit dem Absenden stimmen Sie der Verarbeitung Ihrer Daten gemäß
                unserer{" "}
                <Link className="contact__privacy-link" to="/datenschutz">
                  Datenschutzerklärung
                </Link>{" "}
                zu.
              </p>
            </form>
          </div>

          <div className="contact__info">
            <span className="contact__aside-label">Direct contact</span>
            <h3>Good work starts with a good conversation.</h3>
            <p>
              Feel free to reach out for opportunities, collaborations, or just
              to say hello. I'm always open to a good conversation.
            </p>
            <div className="contact__info-items">
              <div className="contact__info-item">
                <div className="contact__info-item-icon">
                  <FiMapPin />
                </div>
                <div>
                  <h4>Location</h4>
                  <p>Augsburg, Germany</p>
                </div>
              </div>
              <div className="contact__info-item">
                <div className="contact__info-item-icon">
                  <FiPhone />
                </div>
                <div>
                  <h4>Phone</h4>
                  <p>+49 163 3833515</p>
                </div>
              </div>
              <div className="contact__info-item">
                <div className="contact__info-item-icon">
                  <FiMail />
                </div>
                <div>
                  <h4>Email</h4>
                  <p>contact@alexrodriguezvera.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
